import { Omit } from '@40seas/entities/common';
import { InsuranceCover } from './insurance.covers.entity';
import { BaseEntityFieldsArray } from '@40seas/models';

export class CreateInsuranceCoverDto extends Omit(InsuranceCover, [...BaseEntityFieldsArray]) {}
